import { render, staticRenderFns } from "./Leaderboard_EntrySection_Custom.vue?vue&type=template&id=4d0b603c&scoped=true&"
import script from "./Leaderboard_EntrySection_Custom.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_EntrySection_Custom.vue?vue&type=script&lang=js&"
import style0 from "./Leaderboard_EntrySection_Custom.vue?vue&type=style&index=0&id=4d0b603c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0b603c",
  null
  
)

export default component.exports